import React from 'react';
import './VisualInspectionTable.css';

const OPTIONS = ['Bueno', 'Regular', 'Malo', 'N/A'];

const VisualInspectionTable = ({ title, items, values = {}, onChange, disabled = false }) => {
    const handleChange = (itemId, value) => {
        if (!disabled && onChange) {
            onChange(itemId, value);
        }
    };

    return (
        <div className="visual-inspection-table">
            <h3 className="visual-inspection-table-title">{title}</h3>
            <div className="visual-inspection-table-content">
                <table className="visual-inspection-grid">
                    <thead>
                        <tr>
                            <th className="col-area">ÁREA</th>
                            <th className="col-option">Bueno</th>
                            <th className="col-option">Regular</th>
                            <th className="col-option">Malo</th>
                            <th className="col-option">N/A</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item) => (
                            <tr key={item.id}>
                                <td className="col-area">{item.label}</td>
                                {OPTIONS.map((option) => (
                                    <td key={option} className="col-option">
                                        <label className="visual-inspection-radio-label">
                                            <input
                                                type="radio"
                                                name={`visual-${item.id}`}
                                                value={option}
                                                checked={(values[item.id] || '') === option}
                                                onChange={() => handleChange(item.id, option)}
                                                disabled={disabled}
                                                className="visual-inspection-radio"
                                            />
                                        </label>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default VisualInspectionTable;
